















































import { Component, Prop, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";

@Component({
  components: {
    BPopover,
  },
  computed: mapState("gaps", ["priority"]),
})
export default class GapPriorityPopover extends Vue {
  @Model("change") readonly gap!: any;
  id = "priority-popover";
  comment = "";
  loading = false;
  get target() {
    return this.id + "-target-" + this.gap.id;
  }
  async save(priority) {
    if (this.loading) return;
    try {
      this.loading = true;
      await this.$store.dispatch("gaps/savePriority", {
        gapId: this.gap.id,
        priorityId: priority.id,
        comment: this.comment,
      });
      this.gap.priorityId = priority.id;
      this.gap.priorityName = priority.name;
      this.gap.priorityBackColor = priority.backColor;
      this.gap.priorityFontColor = priority.fontColor;
      this.loading = false;
      this.close();
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  close() {
    if (this.loading) return;
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
}
